import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export enum background {
  SUN = 0,
  MOON = 1
}
interface backgroundColorI {
  detailsPageBackground: background
  analysisBackground: background
}

const initialState: backgroundColorI = {
  detailsPageBackground: background.SUN,
  analysisBackground: background.MOON
}

export const setBackgroundColorSlice = createSlice({
  name: 'setBackgroundColor',
  initialState,
  reducers: {
    setDetailsPageBackground: (state, action: PayloadAction<background>) => {
      state.detailsPageBackground = action.payload
    },
    setAnalysisBackground: (state, action: PayloadAction<background>) => {
      state.analysisBackground = action.payload
    }
  }
})
export const { setDetailsPageBackground, setAnalysisBackground } = setBackgroundColorSlice.actions
export default setBackgroundColorSlice.reducer
